import React from "react";
import HomePage from "pages/home";
import QuestionPage from "pages/questions";
import RulesPage from "pages/rules";
import PrizePage from "pages/prize";
// import GamePage from "pages/game";
import Pc from "pages/pc";
import VerifiSuccessPage from "pages/verifi-success";

const routesCampaign = [
  {
    path: "/" || "/#guide" || "/#joinNow",
    name: "Trang chủ",
    element: <HomePage />,
  },
  {
    path: "/prize",
    name: "Danh sách trúng thưởng",
    element: <PrizePage />,
  },
  {
    path: "/rule",
    name: "Thể lệ",
    element: <RulesPage />,
  },
  {
    path: "/question",
    name: "Câu hỏi thường gặp",
    element: <QuestionPage />,
  },

  {
    path: "/verifi-success",
    name: "Xác thực thành công",
    element: <VerifiSuccessPage />,
  },
  {
    path: "/pc",
    name: "",
    element: <Pc />,
  },
  // {
  //   path: "/thongtintichluy",
  //   name: "Thông tin tích lũy",
  //   element: () => {
  //     window.open("https://platform-customer-web-qa.akachains.io/main/loyalty");
  //     return true;
  //   },
  // },
];

export default routesCampaign;
